import { render, staticRenderFns } from "./inventoryStockType.vue?vue&type=template&id=12a9f8fb&"
import script from "./inventoryStockType.vue?vue&type=script&lang=js&"
export * from "./inventoryStockType.vue?vue&type=script&lang=js&"
import style0 from "./inventoryStockType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports